import {
  LessonPattern,
  Substitution,
  TimeTableLesson,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';

/**
 * Base interface for TimeTableLesson that works with both
 * @mnspro-cloud/services (TimeTableLesson with LessonState enum) and
 * @mnspro-cloud/teams-services (TimeTableLessonTeams with string state).
 *
 * This abstraction allows the TimetablePeriod component to be used
 * in both the web-app and teams-app-cockpit without type casting.
 */
export interface TimeTableLessonBase {
  azureId?: string | null;
  classes?: string[];
  color?: string | null;
  id?: string | null;
  to?: string;
  exam?: boolean;
  event?: boolean;
  lessonId?: string;
  multiLessonId?: string;
  title?: string;
  cardinalNumber?: number;
  room?: string | null;
  roomId?: string | null;
  from?: string;
  /** State can be LessonState enum (services) or string (teams-services) */
  state?: string;
  teacher?: string | null;
  teacherMail?: string | null;
}

/**
 * Abstracted event data interface to decouple from FullCalendar's EventApi
 */
export interface TimetablePeriodEventData {
  id: string;
  title?: string;
  startStr: string;
  endStr: string;
}

export enum TimetablePeriodViewerRole {
  Staff = 'staff',
  Student = 'student',
}

export interface TimetablePeriodProps {
  eventData: TimetablePeriodEventData;
  timeTableLesson: TimeTableLesson | null;
  viewerRole: TimetablePeriodViewerRole;
  substitution: Substitution | null;
  isMobileView: boolean;
  lessonPattern: LessonPattern[] | null;

  // Navigation callbacks (optional - wenn nicht gesetzt, werden die Buttons nicht angezeigt)
  onNavigateToCoursebook?: (courseId: string, lessonId: string) => void;
  onNavigateToAbsences?: (courseId: string) => void;
  onNavigateToSubstitution?: (lessonId: string, hasExistingSubstitution: boolean) => void;

  // Permission flags (optional - wenn nicht gesetzt, werden die Buttons nicht angezeigt)
  canShowClassbook?: boolean;
  canShowAbsences?: boolean;
  canManageSubstitutions?: boolean;
}

export interface TimetablePeriodTimeProps {
  eventData: TimetablePeriodEventData;
  timeTableLesson: TimeTableLesson | null;
  substitution: Substitution | null;
  lessonPattern: LessonPattern[] | null;
}

export interface TimetablePeriodSubstitutionInfoRowProps {
  substitution: Substitution;
}
